import type { Obj } from '@oracle/oraclejet-internal-utilities/typeUtils';

// type guard function
export const isObj = (v: unknown): v is Obj => typeof v === 'object';
